import React, { useState } from 'react';
import { StackDivider, VStack } from '@chakra-ui/react';
import { uniqBy, prop } from 'ramda';
import ScrollableWrapper from '../FindingsWrapper/ScrollableWrapper';
import RemoteSubmissionPanel from './Panel/RemoteSubmissionPanel';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
import OfficerAssessmentModal from '../OfficerAssessments/OfficerAssessmentModal';
import { UnsavedChangesProvider } from '../UnsavedChanges/UnsavedChangesProvider';
import { queryClient } from '../../../services/api/query/queryClient';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import AddOfficerAssessmentPanel from '../OfficerAssessments/Panel/AddOfficerAssessmentPanel';
import RenderIfElse from '../RenderIf/RenderIfElse';
import OfficerAssessmentPanel from '../OfficerAssessments/Panel/OfficerAssessmentPanel';
import { getGetInspectionRemoteSubmissionLocationsQueryKey } from '../../../services/api/generated/client';
import useExpandableAccordion from '../../../hooks/useExpandableAccordion';
const RemoteSubmissionsWrapper = ({ remoteSubmissions, canEdit, }) => {
    const { handleExpand: handlePopoverOpened, expandedIndex: openedIndex } = useExpandableAccordion();
    const { inspection } = useInspectionDetailContext();
    const [officerAssessment, setOfficerAssessment] = useState();
    const tokens = useTokens();
    if (!remoteSubmissions?.length) {
        return null;
    }
    const handleOfficerAssessmentCreated = (createdOfficerAssessment) => {
        queryClient.invalidateQueries({
            queryKey: getGetInspectionRemoteSubmissionLocationsQueryKey(inspection.id),
        });
        setOfficerAssessment(createdOfficerAssessment);
    };
    const contacts = uniqBy(prop('id'), remoteSubmissions.map((submission) => submission.contact));
    const hasMultipleContacts = contacts.length > 1;
    return (React.createElement(React.Fragment, null,
        React.createElement(ScrollableWrapper, { minH: "260px", maxH: "500px", "data-testid": "remote_submissions_wrapper" },
            React.createElement(VStack, { px: tokens.Spacing04, divider: React.createElement(StackDivider, { borderColor: tokens.BorderLight500 }), align: "stretch", py: tokens.Spacing05, spacing: tokens.Spacing05 }, remoteSubmissions.map((remoteSubmission) => (React.createElement(VStack, { spacing: tokens.Spacing05, align: "stretch", key: remoteSubmission.id },
                React.createElement(RemoteSubmissionPanel, { hasMultipleContacts: hasMultipleContacts, handlePopoverOpened: handlePopoverOpened, openedIndex: openedIndex, remoteSubmission: remoteSubmission }),
                React.createElement(RenderIfElse, { condition: !!remoteSubmission.officer_assessment, then: React.createElement(OfficerAssessmentPanel, { remoteSubmission: remoteSubmission, officerAssessment: remoteSubmission.officer_assessment }), else: React.createElement(AddOfficerAssessmentPanel, { canEdit: canEdit, handleOfficerAssessmentCreated: handleOfficerAssessmentCreated, remoteSubmission: remoteSubmission }) })))))),
        React.createElement(RenderIf, { condition: officerAssessment != null },
            React.createElement(UnsavedChangesProvider, null,
                React.createElement(OfficerAssessmentModal, { canEdit: true, onClose: () => {
                        setOfficerAssessment(undefined);
                    }, officerAssessment: officerAssessment })))));
};
export default RemoteSubmissionsWrapper;
